import { SpinnerCircular } from "spinners-react"
import styles from "./PageLoader.module.scss"

export const PageLoader = () => {
  return (
    <div className={styles.pageLoader} role="status" aria-busy="true">
      <SpinnerCircular
        size={48}
        thickness={120}
        speed={120}
        color="#f0f0f0"
        secondaryColor="#3a3a3a"
      />
    </div>
  )
}
